<template>
  <van-overlay :show="showAlert" style="z-index: 102;">
    <div
        style="width:100%;height:100%;display: flex;align-items: center;justify-content: center;flex-direction: column;">
      <div :style='{
      backgroundImage:`url(${alert_bg})`,
      backgroundRepeat: "no-repeat",
      height:"80px",
      width:"80%",
      backgroundSize: "100% 100%",
      backgroundPosition: "left",
      display:"flex",
      alignItems:"flex-start",
    }' class="gameAlertDiv">
        <div
            style="margin-left: 10px;margin-top:20px;display: flex;flex-direction: row;justify-content: flex-start;align-items: flex-end;">
          <div :style="hcf.getTextStyle({
            color:'white',addSize:5,fontWeight:'bold',marginLeft:5
          })">{{ originData["gameName"] }}
          </div>
          <div :style="hcf.getTextStyle({
            color:'#ccc',addSize:-2,marginLeft:5,marginBottom:1,
          })">即将进入游戏
          </div>
        </div>
        <div
            style="margin-bottom: 10px;margin-left: 10px;padding: 3px 30px 3px 5px;border-bottom-left-radius: 30px;border-top-left-radius: 30px;display: flex;flex-direction: row;align-items: center;background: linear-gradient(90deg, var(--ct-main-color-bg) 70%, #fff0)">
          <div :style="hcf.getTextStyle({
            color:'main',marginLeft:5,marginBottom:1,marginRight:5
          })">账户总余额:
          </div>
          <div v-if='respData["TotalBalance"] !== 0' :style="hcf.getTextStyle({
            color:'#E08900',addSize:2,marginBottom:1,
          })">{{ hcf.getMoneyValue(respData["TotalBalance"] ?? 0) }}
          </div>
          <HRotateImg v-if='respData["TotalBalance"] === 0' :isLooper="true" width="16"/>
        </div>
      </div>
      <div
          style="background-color: var(--ct-main-color-bg);width:80%;display: flex;flex-direction: row;padding:3px;align-items: center;">
        <div :style="hcf.getTextStyle({
            marginLeft:15,marginBottom:1,marginRight:5
          })">正在结算金额:
        </div>
        <div v-if='!(respData["SettleBalance"] === 0 &&
                              ("List" in respData) &&
                              respData["List"] != null &&
                              respData["List"].length>0)' :style="hcf.getTextStyle({
            addSize:2,
          })">{{ hcf.getMoneyValue(respData["SettleBalance"] ?? 0) }}
        </div>
        <HRotateImg v-if='(respData["SettleBalance"] === 0 &&
                              ("List" in respData) &&
                              respData["List"] != null &&
                              respData["List"].length>0)' :isLooper="true" width="15"/>
      </div>
      <div style="border-bottom-right-radius: 10px;border-bottom-left-radius: 10px;width:80%;background-color: white;display: flex;flex-direction: column;">
        <div style="display: flex;flex-direction: row;align-items: center;background-color: white;">
          <div style="width:30%">
            <div :style="hcf.getTextStyle({
            color:'#555',textAlign:'center',
          })">游戏
            </div>
          </div>
          <div style="width:30%">
            <div :style="hcf.getTextStyle({
            color:'#555',textAlign:'center',
          })">冻结金额
            </div>
          </div>
          <div style="width:40%">
            <div :style="hcf.getTextStyle({
            color:'#555',textAlign:'center',
          })">状态
            </div>
          </div>
        </div>
        <div
            style="background-color: white;height:160px;overflow-y: auto;-webkit-overflow-scrolling: touch;">
          <div style="padding:3px 0;display: flex;flex-direction: row;align-items: center;"
               v-for='eachItem in (respData["List"]??[])'>
            <div style="width:30%">
              <div :style="hcf.getTextStyle({
            color:'#555',textAlign:'center',
          })">{{ eachItem["PlatWalletName"] }}
              </div>
            </div>
            <div style="width:30%">
              <div :style="hcf.getTextStyle({
            color:'#555',textAlign:'center',
          })">{{ hcf.getMoneyValue(eachItem["SettleBalance"]) }}
              </div>
            </div>
            <div style="display:flex;flex-direction:row;align-items:center;justify-content:center;width:40%">
              <div :style="hcf.getTextStyle({
              color:'#555',textAlign:'center',marginRight:2
            })">{{ getStateText(eachItem) }}
              </div>

              <div @click="downScoreNow(eachItem)"
                   v-if='eachItem["TaskStatus"] === 0 || eachItem["TaskStatus"] === 4 || eachItem["TaskStatus"] === 5'
                   style="background-color: var(--ct-main-color);border-radius: 4px;padding:0 3px;">
                <div :style="hcf.getTextStyle({
                color:'#fff',textAlign:'center',addSize:-2
              })">立即下分
                </div>
              </div>
              <HRotateImg
                  v-if='!(eachItem["TaskStatus"] === 0 || eachItem["TaskStatus"] === 4 || eachItem["TaskStatus"] === 5)'
                  :isLooper="true" width="15"/>
            </div>
          </div>
        </div>
        <div
            style="margin-top: 5px;padding:2px 20px;display: flex;flex-direction: row;align-items: center;background-color: white;">
          <div :style="hcf.getTextStyle({
                color:'#6B7280',textAlign:'left',addSize:-2
              })">{{ '1: 正在自动从游戏下分，预计0~1分钟内完成\n2:下分完成后，即可带入游戏' }}
          </div>
        </div>
        <div
            style="padding:5px 20px;display: flex;flex-direction: row;justify-content: center;align-items: center;background-color: white;">
          <div :style="hcf.getTextStyle({
                color:'main',marginRight:6,
              })">当前可带入游戏金额:
          </div>
          <div :style="hcf.getTextStyle({
                color:'#E08900',addSize:2,
              })">{{ hcf.getMoneyValue(respData["AvailableBalance"] ?? 0) }}
          </div>
        </div>
        <div
            style="margin-bottom:15px;display: flex;flex-direction: row;justify-content: space-around;align-items: center;background-color: white;">
          <div @click="dontIntoNow"
               style="background-color: white;box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);padding:10px 26px;border-radius:6px;">
            <div :style="hcf.getTextStyle({
                textAlign:'center',
              })">暂不进入
            </div>
          </div>
          <div
              style="background-color: var(--ct-main-color);box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);padding:10px 26px;border-radius:6px;">
            <div @click="intoGameNow" :style="hcf.getTextStyle({
                textAlign:'center',color:'white'
              })">立即进入
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>


<script setup>
  import {useUserStore} from "@/stores/useUser.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import alert_bg from "@/assets/icons/common/alert_bg.png"
  import {emitter, hcf, log} from "@/components/utils/HComFunctions.js";
  import HRotateImg from "@/components/utils/HRotateImg.vue";

  const user = useUserStore();
  const http = useHHttp();
  const respData = ref();

  const isIngGame = ref(false);
  const showAlert = ref(false);
  const originData = ref();
  let refreshTimer = null;

  function dontIntoNow() {
    showAlert.value = false;
    if (refreshTimer) {
      clearTimeout(refreshTimer);
      refreshTimer = null;
    }
  }

  function inGame(confirm, balance) {
    isIngGame.value = true;
    http.request("/game/enter", (data) => {
      showAlert.value = false;
      emitter.emit("EVENT_INTO_GAME", {"game_url": data["GameUri"], "game_id": originData.value.gameId,leaveArgument: originData.value["leaveArgument"]})
    }, {
      params: {
        "UserId": user.userId,
        "GameId": originData.value.gameId,
        "Balance": balance,
        "Confirm": confirm,
      }, loadingDelayMillTime: 50, loadingText: "正在进入游戏"
    });
  }

  function intoGameNow() {
    inGame(1, respData["AvailableBalance"]);
  }

  function downScoreNow(e) {
    if (e["TaskStatus"] === 0 || e["TaskStatus"] === 4 || e["TaskStatus"] === 5) {
      http.request(
          "/game/balance-down",
          () => {
          },
          {
            params: {
              "UserId": user.userId,
              "ApiPlat": e["ApiPlat"],
              "PlatWallet": e["PlatWallet"],
            },
            loadingText: "正在下分"
          });
    }
  }

  function getStateText(e) {
    let taskStatusText = "下分中";
    switch (e["TaskStatus"]) {
      case 0:
        taskStatusText = "准备下分"; //之前的[等待]状态
        break;
      case 1:
        taskStatusText = "下分中";
        break;
      case 2:
        taskStatusText = "已完成";
        break;
      case 3:
        taskStatusText = "重试中";
        break;
      case 4:
        taskStatusText = "游戏中";
        break;
      case 5:
        taskStatusText = "异常退出";
        break;
      case -1:
        taskStatusText = "中断";
        break;
    }
    return taskStatusText;
  }

  function refreshData() {
    http.request("/game/entry-alert", (data) => {
          if (!isIngGame.value) {
            respData.value = data;
            if (refreshTimer) {
              clearTimeout(refreshTimer);
              refreshTimer = null;
            }
            if(showAlert.value){
              refreshTimer = setTimeout(() => {
                refreshData();
              },2000);
            }
          }
        },
        {
          isShowLoading: false,
          params: {
            "UserId": user.userId,
          },
        }
    );
  }

  onMounted(() => {
    emitter.on("EVENT_INTO_GAME_ALERT", (data) => {
      showAlert.value = true;
      originData.value = data;
      respData.value = data["initData"];
      refreshData();
    });
  });
  onUnmounted(() => {
    emitter.off("EVENT_INTO_GAME_ALERT");
  });


</script>


<style scoped>
  .gameAlertDiv {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
</style>
